module.exports = __webpack_public_path__ + "static/media/reports.empty.3163a410.png";